import { InventorySourceSchema } from "@redotech/redo-model/fulfillments/inventory-source";
import { locationIdFormat } from "@redotech/redo-model/ids";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { PickSessionStrategy } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createPickSession = {
  name: "createPickSession" as const,
  input: z.object({
    numberOfGroups: z.number().int().min(1).max(100),
    searchInput: AdvancedFilterInputSchema,
    locationId: locationIdFormat.schema,
    strategy: createEnum(PickSessionStrategy),
    inventorySource: InventorySourceSchema.optional(),
    seedGroupId: zExt.objectId().nullish(),
    assignedUserId: zExt.objectId().optional(),
    // Set on the new session's `assigningUser` field. Callers that queue a
    // session for someone (or for themselves out-of-band, e.g. the bulk-
    // create-from-FG flow) pass this; the regular WMS create flow leaves
    // it unset.
    assigningUserId: zExt.objectId().optional(),
    toteIds: z.array(zExt.objectId()).optional(),
    pollForOpenSearchChanges: z.boolean().optional(),
    filterName: z.string().nullish(),
    useIncremental: z.boolean().optional(),
    // When true and strategy is MULTI_ITEM, allow single-item orders to be
    // included in the session by dropping the `expandedItemQuantity > 1`
    // strategy filter. Has no effect on SINGLE_ITEM sessions — those must
    // still enforce `expandedItemQuantity == 1` since multi-item orders
    // can't be picked under the single-item flow. Behaves the same as the
    // team-level forceMultiItemPickSessions setting, but per-call. Used by
    // hand-picked flows (bulk-from-table) where the caller has chosen
    // specific FG ids and shouldn't have them silently filtered.
    allowSingleItemInMultiSession: z.boolean().optional(),
  }),
  output: z.object({
    pickSessionId: zExt.objectId().optional(),
    rejectedGroups: z
      .array(
        z.object({
          groupId: zExt.objectId(),
          orderNames: z.array(z.string()),
          reason: z.string(),
          productSku: z.string().optional(),
          productVariantTitle: z.string().optional(),
          productImageUrl: z.string().optional(),
        }),
      )
      .optional(),
  }),
};
